module.exports = __webpack_public_path__ + "img/dutyfree4.aa8c2173.png";